/* SV Zapis do newslettera nad stopką (sections/sv-zapis.liquid, 19.10.2026, sesja 7ea9476e).
   Zapis przez Klaviyo Client API jak w assets/sv-goal-popup.js (rewizja 2026-07-15, subscriptions + events).
   Zasady (docs/research/zapis-stopka-2026-10-18/DECYZJE.md, poprawki po recenzji H-recenzja-kodu.md):
   - sukces WYŁĄCZNIE po odpowiedzi 2xx subskrypcji (Nuffy pokazywał sukces także przy błędzie),
   - zdarzenie „SkinVibe Footer Signup” (dowód zgody, licznik źródła) PRZED subskrypcją, bo warunek K2 w Welcome
     czyta je przy wejściu do automatu (19.10, zmienia H Y3); „... Phone Consent” po udanej subskrypcji telefonu,
   - pole-pułapka = pozorny sukces bez wysyłki i bez kroku telefonu; wysyłka szybciej niż 2 s od wczytania
     NIE jest odrzucana, tylko czeka do 2 s (H Y2: szybka klientka z autouzupełnianiem),
   - najwyżej 5 wysyłek na sesję (Klaviyo chroni przed botami tylko w swoich formularzach),
   - po zapisie wspólny klucz z popupem (sv_popup_v1_done), narożnik flyoutu znika od razu,
     a gdy sekcja jest na ekranie, narożnik ustępuje (klasa sv-zapis-yield, H Y8),
   - pomiar sv_footer_signup przez window.svTrack (assets/sv-events.js: zgoda, GA4, Shopify.analytics), bez e-maila
     i numeru; „view” raz na odsłonę i „already_shown” raz na sesję, oba dopiero, gdy sekcja jest na ekranie (H Y10). */
(function () {
  'use strict';
  var REV = '2026-07-15';
  var RE_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var KEY_DONE = 'sv_popup_v1_done';
  var KEY_NL = 'sv_nl_v1';
  var KEY_SENT = 'sv_nl_sent_v1';
  var KEY_ALREADY = 'sv_nl_already_v1';
  var MIN_MS = 2000;
  var RE_INTERIA = /@(interia\.(pl|eu|com)|vip\.interia\.pl|poczta\.fm|int\.pl)$/i;
  var MAX_SENDS = 5;
  var T0 = Date.now();

  function getLS(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function setLS(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  function getSS(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function setSS(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }

  function track(data) {
    try { if (window.svTrack) window.svTrack('sv_footer_signup', data); } catch (e) {}
  }
  /* UTM sesji: popup zapisuje utm_source/utm_medium/utm_campaign (sv-goal-popup.js), adres strony jako zapas */
  function utm() {
    var out = {};
    try {
      var raw = getSS('sv_popup_utm_v1');
      var u = raw ? JSON.parse(raw) : null;
      var p = new URLSearchParams(location.search);
      var src = (u && (u.utm_source || u.source)) || p.get('utm_source');
      var med = (u && (u.utm_medium || u.medium)) || p.get('utm_medium');
      var cmp = (u && (u.utm_campaign || u.campaign)) || p.get('utm_campaign');
      if (src) out.signup_utm_source = String(src).slice(0, 100);
      if (med) out.signup_utm_medium = String(med).slice(0, 100);
      if (cmp) out.signup_utm_campaign = String(cmp).slice(0, 100);
    } catch (e) {}
    return out;
  }
  function normalizePhone(raw) {
    var d = (raw || '').replace(/[^0-9]/g, '');
    if (d.indexOf('0048') === 0) d = d.slice(4);
    else if (d.indexOf('48') === 0 && d.length === 11) d = d.slice(2);
    if (d.length === 9 && /^[45678]/.test(d)) return '+48' + d;
    return null;
  }
  function focusEl(el) { if (el) { try { el.focus({ preventScroll: true }); } catch (e) {} } }

  /* podpowiedź literówki w domenie (gmial.com -> gmail.com); nic nie wysyła, tylko proponuje */
  var DOMAINS = ['gmail.com', 'wp.pl', 'o2.pl', 'onet.pl', 'op.pl', 'onet.eu', 'interia.pl', 'interia.eu', 'poczta.fm', 'vp.pl',
    'gazeta.pl', 'tlen.pl', 'poczta.onet.pl', 'icloud.com', 'me.com', 'outlook.com', 'hotmail.com', 'live.com', 'yahoo.com',
    'gmx.de', 'web.de', 't-online.de', 'gmx.net', 'aol.com', 'seznam.cz', 'centrum.cz', 'orange.fr', 'libero.it'];
  function dist(a, b) {
    if (Math.abs(a.length - b.length) > 2) return 9;
    var prev = [], cur, i, j;
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++) {
      cur = [i];
      for (j = 1; j <= b.length; j++) cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
      prev = cur;
    }
    return prev[b.length];
  }
  function suggest(email) {
    var at = email.lastIndexOf('@');
    if (at < 1) return null;
    var dom = email.slice(at + 1).toLowerCase();
    if (DOMAINS.indexOf(dom) >= 0) return null;
    var best = null, bd = 9;
    DOMAINS.forEach(function (d) {
      var x = dist(dom, d), lim = d.length <= 6 ? 1 : 2;
      if (x <= lim && x < bd) { bd = x; best = d; }
    });
    return best ? email.slice(0, at + 1) + best : null;
  }

  function init(root) {
    if (!root || root.dataset.svZapisBooted === '1') return;
    root.dataset.svZapisBooted = '1';
    var D = root.dataset;
    var card = root.querySelector('.sv-zapis__card') || root;
    var form = root.querySelector('[data-sv-zapis-form]');
    var inpEmail = root.querySelector('[data-sv-zapis-email]');
    var hp = root.querySelector('[data-sv-zapis-hp]');
    var consent = root.querySelector('[data-sv-zapis-consent]');
    var err = root.querySelector('[data-sv-zapis-err]');
    var btn = root.querySelector('[data-sv-zapis-submit]');
    var done = root.querySelector('[data-sv-zapis-done]');
    var doneH = root.querySelector('[data-sv-zapis-done-h]');
    var already = root.querySelector('[data-sv-zapis-already]');
    var again = root.querySelector('[data-sv-zapis-again]');
    var phoneForm = root.querySelector('[data-sv-zapis-phone-form]');
    var inpTel = root.querySelector('[data-sv-zapis-tel]');
    var errTel = root.querySelector('[data-sv-zapis-tel-err]');
    var btnTel = root.querySelector('[data-sv-zapis-tel-submit]');
    var skip = root.querySelector('[data-sv-zapis-skip]');
    var phoneOk = root.querySelector('[data-sv-zapis-phone-ok]');
    var hint = root.querySelector('[data-sv-zapis-hint]');
    var echo = root.querySelector('[data-sv-zapis-echo]');
    var benefits = root.querySelector('[data-sv-zapis-benefits]');
    var vOffer = root.querySelectorAll('[data-sv-zapis-offer]');
    var vNoffer = root.querySelectorAll('[data-sv-zapis-noffer]');
    var interia = root.querySelector('[data-sv-zapis-interia]');
    var interiaPre = root.querySelector('[data-sv-zapis-interia-pre]');
    var again2 = root.querySelector('[data-sv-zapis-again2]');
    if (!form || !inpEmail || !btn) return;
    var btnLabel = btn.textContent;
    var base = { offer: D.offer || 'brak', layout: 'v1' };
    var savedEmail = '';
    var isAlready = false;

    /* zapisana wcześniej w tej przeglądarce (stopka, flyout, popup) albo zalogowana ze zgodą = krótki stan;
       nagłówek bez oferty i bez listy korzyści (nie „Odbierz -5%” nad „Jesteś już z nami”, recenzja G pkt 18) */
    function setAlready(on) {
      isAlready = on;
      form.hidden = on;
      if (already) already.hidden = !on;
      [].forEach.call(vOffer, function (el) { el.hidden = on; });
      [].forEach.call(vNoffer, function (el) { el.hidden = !on; });
      if (benefits && vOffer.length) benefits.hidden = on;
    }
    if (D.already === '1' || getLS(KEY_DONE) === '1' || getLS(KEY_NL)) setAlready(true);
    if (again) again.addEventListener('click', function () {
      setAlready(false);
      focusEl(inpEmail);
    });
    if (again2) again2.addEventListener('click', function () {
      done.hidden = true;
      if (interia) interia.hidden = true;
      if (phoneForm) phoneForm.hidden = false;
      form.hidden = false;
      inpEmail.value = '';
      focusEl(inpEmail);
    });

    /* sekcja na ekranie: pomiar wyświetlenia i ustąpienie narożnika flyoutu (ten sam zapis, nie zasłania przycisku) */
    if ('IntersectionObserver' in window) {
      var seen = false;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var vis = en.isIntersecting;
          try { document.querySelectorAll('[data-svgp-teaser]').forEach(function (t) { t.classList.toggle('sv-zapis-yield', vis); }); } catch (e) {}
          if (vis && !seen && en.intersectionRatio >= 0.25) {
            seen = true;
            if (isAlready) {
              if (!getSS(KEY_ALREADY)) { setSS(KEY_ALREADY, '1'); track(Object.assign({ step_name: 'email', action: 'already_shown' }, base)); }
            } else {
              track(Object.assign({ step_name: 'email', action: 'view' }, base));
            }
          }
        });
      }, { threshold: [0, 0.25] }).observe(card);
    }

    function klPost(path, payload) {
      var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
      var t = ctrl ? setTimeout(function () { ctrl.abort(); }, 10000) : null;
      return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(D.klCompany || ''), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', 'revision': REV },
        body: JSON.stringify(payload),
        signal: ctrl ? ctrl.signal : undefined
      }).then(function (r) { if (t) clearTimeout(t); return r; }, function (e) { if (t) clearTimeout(t); throw e; });
    }

    /* wynik: 'ok' | 'bad' (4xx poza 429: adres odrzucony) | 'fail' (sieć, 429, 5xx, bloker) */
    function result(r) {
      if (r && r.ok) return 'ok';
      if (r && r.status >= 400 && r.status < 500 && r.status !== 429) return 'bad';
      return 'fail';
    }

    function saveEmail(email) {
      var now = new Date().toISOString();
      var props = Object.assign({
        signup_source: 'stopka',
        signup_market: D.market || 'PL',
        signup_language: D.lang || '',
        consent_email: true,
        consent_email_text_version: D.vEmail || '',
        consent_email_at: now,
        signup_offer: D.offer || 'brak',
        signup_page: location.pathname,
        footer_layout: 'v1'
      }, utm());
      var profileProps = {
        sv_signup_source: 'stopka',
        signup_market: props.signup_market,
        signup_language: props.signup_language,
        consent_email_text_version: props.consent_email_text_version,
        consent_email_at: now
      };
      /* zdarzenie PRZED subskrypcją (19.10, K2 sesji maili): Welcome TPwYx4 sprawdza „SkinVibe Footer Signup”
         w chwili wejścia do automatu, czyli zaraz po zapisie na listę; zdarzenie po subskrypcji przegrywało ten wyścig
         i osoba po zakupie albo w trakcie kasy dostawała mail bez kodu. Czekamy najwyżej 2,5 s, błąd zdarzenia nie
         blokuje zapisu. Nieudana subskrypcja zostawia zdarzenie (kliknięcie zgody było), mierzy to save_failed. */
      var ev = klPost('events', {
        data: {
          type: 'event',
          attributes: {
            properties: props,
            metric: { data: { type: 'metric', attributes: { name: 'SkinVibe Footer Signup' } } },
            profile: { data: { type: 'profile', attributes: { email: email, properties: profileProps } } }
          }
        }
      }).then(null, function () {});
      return Promise.race([ev, new Promise(function (ok) { setTimeout(ok, 2500); })]).then(function () {
        return klPost('subscriptions', {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: D.source || 'Newsletter w stopce',
              profile: { data: { type: 'profile', attributes: {
                email: email,
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              } } }
            },
            relationships: { list: { data: { type: 'list', id: D.klList } } }
          }
        });
      }).then(function (r) { return result(r); }, function () { return 'fail'; });
    }

    function savePhone(email, phone) {
      var now = new Date().toISOString();
      var props = {
        signup_source: 'stopka',
        phone_consent: true,
        sms_consent: true,
        whatsapp_consent: true,
        phone_consent_channels: 'sms_whatsapp',
        phone_consent_text_version: D.vPhone || '',
        phone_consent_at: now
      };
      return klPost('subscriptions', {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: (D.source || 'Newsletter w stopce') + ' (telefon)',
            profile: { data: { type: 'profile', attributes: {
              email: email,
              phone_number: phone,
              /* zgoda nazywa oba kanały (stopka-tel-v1) -> SMS + WhatsApp jednym wywołaniem, jak popup-tel-v1 */
              subscriptions: {
                sms: { marketing: { consent: 'SUBSCRIBED' } },
                whatsapp: { marketing: { consent: 'SUBSCRIBED' } }
              }
            } } }
          },
          relationships: { list: { data: { type: 'list', id: D.klSmsList } } }
        }
      }).then(function (r) {
        var res = result(r);
        if (res === 'ok') {
          klPost('events', {
            data: {
              type: 'event',
              attributes: {
                properties: props,
                metric: { data: { type: 'metric', attributes: { name: 'SkinVibe Footer Phone Consent' } } },
                profile: { data: { type: 'profile', attributes: { email: email, properties: props } } }
              }
            }
          }).then(null, function () {});
        }
        return res;
      }, function () { return 'fail'; });
    }

    function markDone() {
      setLS(KEY_DONE, '1');
      setLS(KEY_NL, new Date().toISOString());
      /* narożnik flyoutu znika od razu (popup sprawdza klucz dopiero przy następnej stronie) */
      try { document.querySelectorAll('[data-svgp-teaser]').forEach(function (t) { t.hidden = true; }); } catch (e) {}
      try {
        var cp = window.Shopify && window.Shopify.customerPrivacy;
        if (cp && typeof cp.marketingAllowed === 'function' && cp.marketingAllowed() && window.klaviyo && typeof window.klaviyo.identify === 'function') {
          window.klaviyo.identify({ email: savedEmail });
        }
      } catch (e) {}
    }

    function showDone(withPhone) {
      form.hidden = true;
      done.hidden = false;
      if (!withPhone && phoneForm) phoneForm.hidden = true;
      focusEl(doneH);
    }

    var invalidTracked = false;
    function invalid(reason, msg, field) {
      err.textContent = msg;
      if (field) { field.setAttribute('aria-invalid', 'true'); focusEl(field); }
      if (!invalidTracked) { invalidTracked = true; track(Object.assign({ step_name: 'email', action: 'invalid', reason: reason }, base)); }
    }

    function showHint(v) {
      if (interiaPre) interiaPre.hidden = !RE_INTERIA.test(v);
      if (!hint || !D.msgHint) return;
      var s = RE_EMAIL.test(v) ? suggest(v) : null;
      if (!s) { hint.hidden = true; return; }
      hint.textContent = D.msgHint.replace('[email]', s);
      hint.dataset.value = s;
      hint.hidden = false;
    }
    if (hint) hint.addEventListener('click', function () {
      inpEmail.value = hint.dataset.value || inpEmail.value;
      hint.hidden = true;
      inpEmail.setAttribute('aria-invalid', 'false'); err.textContent = '';
      track(Object.assign({ step_name: 'email', action: 'hint_used' }, base));
      focusEl(btn);
    });
    inpEmail.addEventListener('blur', function () {
      var v = (inpEmail.value || '').trim();
      if (v && !RE_EMAIL.test(v)) { err.textContent = D.msgEmail; inpEmail.setAttribute('aria-invalid', 'true'); }
      showHint(v);
    });
    inpEmail.addEventListener('input', function () {
      if (hint && !hint.hidden) hint.hidden = true;
      if (interiaPre && !interiaPre.hidden && !RE_INTERIA.test((inpEmail.value || '').trim())) interiaPre.hidden = true;
      if (inpEmail.getAttribute('aria-invalid') === 'true' && RE_EMAIL.test((inpEmail.value || '').trim())) {
        inpEmail.setAttribute('aria-invalid', 'false'); err.textContent = '';
      }
    });
    if (consent) consent.addEventListener('change', function () {
      if (consent.checked) { consent.setAttribute('aria-invalid', 'false'); if (err.textContent === D.msgConsent) err.textContent = ''; }
    });

    /* kod -5% od razu w koszyku (jak quiz; prośba sesji maili 20.10): tylko oferta bez podwójnej zgody (data-kod), nigdy nie
       nadpisujemy innego kodu, który już jest w koszyku (może być lepszy). Pusty koszyk też: Shopify trzyma kod przy koszyku
       i nalicza go po dodaniu produktu (test 20.10, docs/research/stopka-3-2026-10-19/narzedzia/test_kod_koszyk.py) */
    /* runda 5: skopiowanie kodu z ekranu po zapisie (snippets/sv-kod-kopiuj.liquid wysyła sv:kod-kopiuj) */
    root.addEventListener('sv:kod-kopiuj', function () { track(Object.assign({ step_name: 'email', action: 'kod_kopiuj' }, base)); });
    function kodDoKoszyka() {
      var kod = (D.kod || '').trim();
      if (!kod) return Promise.resolve('brak');
      var ten = function (d) { return String(d.code).toLowerCase() === kod.toLowerCase(); };
      var praca = fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
        if (c.discount_codes && c.discount_codes.length) return c.discount_codes.some(ten) ? 'koszyk' : 'inny';
        return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: kod }) }).then(function (r) { return r.ok ? r.json() : null; }).then(function (c2) {
          return c2 && c2.discount_codes && c2.discount_codes.some(ten) ? 'koszyk' : 'blad';
        });
      }).catch(function () { return 'blad'; });
      return Promise.race([praca, new Promise(function (ok) { setTimeout(function () { ok('czas'); }, 2500); })]);
    }

    function send(email) {
      saveEmail(email).then(function (res) {
        btn.disabled = false;
        btn.textContent = btnLabel;
        if (res !== 'ok') {
          if (res === 'bad') { err.textContent = D.msgEmail; inpEmail.setAttribute('aria-invalid', 'true'); focusEl(inpEmail); }
          else err.textContent = D.msgFail;
          track(Object.assign({ step_name: 'email', action: 'save_failed', reason: res === 'bad' ? 'rejected' : 'network' }, base));
          return;
        }
        savedEmail = email;
        if (echo) echo.textContent = email;
        /* Interia blokuje maile z Klaviyo bez terminu (D&C, 19.10): uczciwa informacja i zapis innym adresem */
        var isInteria = RE_INTERIA.test(email);
        if (interia) interia.hidden = !isInteria;
        if (isInteria) track(Object.assign({ step_name: 'email', action: 'interia_note' }, base));
        markDone();
        track(Object.assign({ step_name: 'email', action: 'saved' }, base));
        btn.disabled = true;
        kodDoKoszyka().then(function (wynik) {
          btn.disabled = false;
          var wKod = root.querySelector('[data-sv-zapis-w-kod]'), wMail = root.querySelector('[data-sv-zapis-w-mail]');
          if (wynik === 'koszyk' && wKod && wMail) {
            wKod.hidden = false;
            wMail.hidden = true;
            var e2 = root.querySelector('[data-sv-zapis-echo2]');
            if (e2) e2.textContent = email;
            doneH = root.querySelector('[data-sv-zapis-done-h2]') || doneH;
          }
          if (wynik !== 'brak') track(Object.assign({ step_name: 'email', action: 'kod_w_koszyku', reason: wynik }, base));
          showDone(true);
        });
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.disabled) return;
      var email = (inpEmail.value || '').trim();
      if (!RE_EMAIL.test(email)) return invalid('email', D.msgEmail, inpEmail);
      if (consent && !consent.checked) return invalid('consent', D.msgConsent, consent);
      err.textContent = '';
      inpEmail.setAttribute('aria-invalid', 'false');
      track(Object.assign({ step_name: 'email', action: 'submitted' }, base));
      /* bot: wypełnione pole-pułapka = pozorny sukces, nic nie wysyłamy, bez kroku telefonu; liczymy, żeby cicha strata była widoczna */
      if (hp && hp.value) { track(Object.assign({ step_name: 'email', action: 'bot_suspect', reason: 'hp' }, base)); showDone(false); return; }
      if (hint) hint.hidden = true;
      var n = parseInt(getSS(KEY_SENT) || '0', 10) || 0;
      if (n >= MAX_SENDS) { err.textContent = D.msgFail; return; }
      setSS(KEY_SENT, String(n + 1));
      btn.disabled = true;
      btn.textContent = D.msgSaving || btnLabel;
      /* szybciej niż 2 s od wczytania: czekamy (klientka widzi „Zapisuję...” chwilę dłużej), nie odrzucamy */
      var wait = MIN_MS - (Date.now() - T0);
      if (wait > 0) setTimeout(function () { send(email); }, wait); else send(email);
    });

    if (phoneForm && inpTel && btnTel) {
      var telLabel = btnTel.textContent;
      phoneForm.addEventListener('submit', function (e) {
        e.preventDefault();
        if (btnTel.disabled) return;
        var phone = normalizePhone(inpTel.value);
        if (!phone) {
          errTel.textContent = D.msgPhone;
          inpTel.setAttribute('aria-invalid', 'true');
          focusEl(inpTel);
          track(Object.assign({ step_name: 'phone', action: 'invalid', reason: 'phone' }, base));
          return;
        }
        if (!savedEmail) { phoneForm.hidden = true; return; }
        errTel.textContent = '';
        inpTel.setAttribute('aria-invalid', 'false');
        track(Object.assign({ step_name: 'phone', action: 'submitted' }, base));
        btnTel.disabled = true;
        btnTel.textContent = D.msgSaving || telLabel;
        savePhone(savedEmail, phone).then(function (res) {
          btnTel.disabled = false;
          btnTel.textContent = telLabel;
          if (res !== 'ok') {
            errTel.textContent = res === 'bad' ? D.msgPhone : D.msgFail;
            track(Object.assign({ step_name: 'phone', action: 'save_failed', reason: res === 'bad' ? 'rejected' : 'network' }, base));
            return;
          }
          track(Object.assign({ step_name: 'phone', action: 'saved' }, base));
          phoneForm.hidden = true;
          if (phoneOk) { phoneOk.hidden = false; focusEl(phoneOk); }
        });
      });
      if (skip) skip.addEventListener('click', function () {
        phoneForm.hidden = true;
        focusEl(doneH);
        track(Object.assign({ step_name: 'phone', action: 'skipped' }, base));
      });
    }
  }

  function boot() { document.querySelectorAll('[data-sv-zapis]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
